// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"VQ-z","categoryName":"WQ-z","categoryNameSearchHeader":"XQ-z","categoryContent":"YQ-z","bottomAligned":"ZQ-z","image":"_Q-z","imageNoBackground":"aR-z"};